import { useMemo } from "react";
import { bindActionCreators } from "@reduxjs/toolkit";
import {
  useAppDispatch,
  useAppSelector,
  type RootState,
} from "../../../store/store";
import { clearAppError, clearAppSession } from "../redux/globalActions";
import { commonActions } from "../redux/slice";

export const useCommon = () => {
  const { is_loading, error, is_page_loading, ws_status } = useAppSelector(
    (state: RootState) => state.common,
  );

  const dispatch = useAppDispatch();
  return useMemo(() => {
    const actions = {
      ...commonActions,
      clearAppError,
      clearAppSession,
    };
    return {
      ...bindActionCreators(actions, dispatch),
      is_loading,
      is_page_loading,
      error,
      ws_status
    };
  }, [dispatch, is_loading, is_page_loading, error, ws_status]);
};

export default useCommon;
